/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  PostApiV1ClassroomdisciplineClassModulesMutationRequest,
  PostApiV1ClassroomdisciplineClassModulesMutationResponse,
  PostApiV1ClassroomdisciplineClassModules400,
  PostApiV1ClassroomdisciplineClassModules401,
  PostApiV1ClassroomdisciplineClassModules500,
} from "../../types/classPlanningClassModuleController/PostApiV1ClassroomdisciplineClassModules.ts";

function getPostApiV1ClassroomdisciplineClassModulesUrl() {
  const res = {
    method: "POST",
    url: `/api/v1/classroomdiscipline/class-modules` as const,
  };
  return res;
}

/**
 * @description Cria o Módulo, vincula Turmas, persiste as Disciplinas/recorrências e gera as Aulas (Planejado). **(Requer Authorization para autenticação)**
 * @summary Criar Módulo (Requer Authorization para autenticação)
 * {@link /api/v1/classroomdiscipline/class-modules}
 */
export async function postApiV1ClassroomdisciplineClassModules(
  data?: PostApiV1ClassroomdisciplineClassModulesMutationRequest,
  config: Partial<
    RequestConfig<PostApiV1ClassroomdisciplineClassModulesMutationRequest>
  > & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    PostApiV1ClassroomdisciplineClassModulesMutationResponse,
    ResponseErrorConfig<
      | PostApiV1ClassroomdisciplineClassModules400
      | PostApiV1ClassroomdisciplineClassModules401
      | PostApiV1ClassroomdisciplineClassModules500
    >,
    PostApiV1ClassroomdisciplineClassModulesMutationRequest
  >({
    method: "POST",
    url: getPostApiV1ClassroomdisciplineClassModulesUrl().url.toString(),
    data: requestData,
    ...requestConfig,
    headers: { "Content-Type": "application/*+json", ...requestConfig.headers },
  });
  return res.data;
}
